import { useEffect, useState } from 'react'

import { useFormik, Form, FormikProvider } from 'formik'
import * as Yup from 'yup'

import MuiTypography from '@mui/material/Typography'
import MuiBox from '@mui/material/Box'

import { useGetUsersQuery } from '../../../../users/slice'
import { useAddRepresentativeToCampaignMutation } from '../../../slice'

import FormikControl from '../../../../../components/formik-control'
import LoadingScreen from '../../../../../components/loading-screen'

const RepresentativeForm = ({ campaign, onSubmitEvent, setSubmitEvent, setShowDrawer }) => {
  const { data: users, isLoading: isUsersLoading } = useGetUsersQuery()
  const [campaignRepresentatives, setCampaignRepresentatives] = useState([])
  const [addRepresentative] = useAddRepresentativeToCampaignMutation()

  // TODO: Remove Representatives already on this campaign
  useEffect(() => {
    if (users) {
      const representatives =
        users
          ?.filter((user) => !campaign.representatives?.some((rep) => rep.id === user.id))
          .map((user) => ({
            key: `${user.givenName} ${user.familyName}`,
            value: user.id,
          })) || []
      const blankOption = {
        key: '< Select User >',
        value: '',
      }
      representatives.unshift(blankOption)
      setCampaignRepresentatives(representatives)
    }
  }, [campaign.representatives, setCampaignRepresentatives, users])

  const initialValues = {
    userId: '',
  }

  const validationSchema = Yup.object({
    userId: Yup.string().required('Required'),
  })

  const onSubmit = async (values) => {
    if (values.userId) {
      await addRepresentative({ campaignId: campaign.id, userId: values.userId })
      setSubmitEvent()
      setShowDrawer(false)
    }
  }

  const formik = useFormik({
    initialValues,
    validationSchema,
    onSubmit,
  })

  useEffect(() => {
    if (onSubmitEvent) {
      formik.handleSubmit()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [onSubmitEvent])

  if (isUsersLoading)
    return (
      <div>
        <LoadingScreen width="100%" height="100%" />
      </div>
    )

  if (campaignRepresentatives.length === 1)
    return (
      <MuiBox sx={{ maxWidth: '400px' }}>
        <MuiTypography>
          No additional representatives found. Add users in order to be able to add them as representatives to the
          campaign.
        </MuiTypography>
      </MuiBox>
    )

  return (
    <FormikProvider value={formik}>
      <Form>
        <MuiBox>
          <FormikControl
            control="select"
            label="Representative"
            name="userId"
            options={campaignRepresentatives}
            fullWidth
          />
        </MuiBox>
      </Form>
    </FormikProvider>
  )
}

export default RepresentativeForm
